import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faAlarmExclamation } from '@fortawesome/pro-solid-svg-icons/faAlarmExclamation'
import { faCalendarXmark } from '@fortawesome/pro-solid-svg-icons/faCalendarXmark'
import { faCalendarStar } from '@fortawesome/pro-solid-svg-icons/faCalendarStar'
import { CourseStateType } from 'enum/course-state.enum'

export interface CourseStateVisual {
  id: CourseStateType
  color: string
  icon: IconDefinition
}

export const courseStateVisuals: CourseStateVisual[] = [
  {
    id: CourseStateType.Draft,
    color: '#D9D9D9',
    icon: faPen,
  },
  {
    id: CourseStateType.Published,
    color: '#00B47C',
    icon: faCheckCircle,
  },
  {
    id: CourseStateType.Soon,
    color: '#FFC500',
    icon: faCalendarStar,
  },
  {
    id: CourseStateType.Imparted,
    color: '#9ECFFA',
    icon: faAlarmExclamation,
  },
  {
    id: CourseStateType.Inactive,
    color: '#757575',
    icon: faCalendarXmark,
  },
]
